<div *ngIf="!habilitarAcessarVdp" class="alert alert-info" role="alert">
  <fa-icon [icon]="iconInfo" size="sm"></fa-icon>&nbsp;Não compartilhe o link de
  acesso à lista VDP. Pessoas com acesso a este link poderão preencher o
  formulário indevidamente.
</div>
<div class="row">
  <div class="col-lg-4 mb-2 mb-lg-0">
    <titulo-modal>
      Formulário VDP
      <ng-container *ngIf="showSpanProcessSelectVcp; else empty">
        <span class="choice-span">
          {{ isEscolhidoFoiBci ? "- Optante BCI" : "- Não Optante BCI" }}</span
        >
      </ng-container>
      <ng-template #empty>
        <fa-icon
          [icon]="['fas', 'info-circle']"
          size="sm"
          style="color: black"
          [ngbTooltip]="exampleTooltip"
        ></fa-icon>
        <ng-template #exampleTooltip>
          O formulário ainda não foi enviado
        </ng-template>
      </ng-template>
    </titulo-modal>
    <div class="row button-content-responsive">
      <ng-container
        *ngIf="
          isStartEtapaVdpVar && isSafraVigenteOuSuperior;
          then alreadyStartEtapaVdp;
          else needStartEtapaVdp
        "
      >
      </ng-container>
      <ng-template #alreadyStartEtapaVdp>
        <div class="col-lg-12 button-responsive">
          <button
            [disabled]="
              (habilitarAcessarVdp || loadingButton) && isSafraVigenteOuSuperior
            "
            (click)="preencherVdp()"
            class="btn btn-sm btn-primary"
          >
            <fa-icon [icon]="icon" size="sm"></fa-icon>&nbsp;Acessar VDP
          </button>
        </div>
        <div class="col-lg-12 resume-button-responsive">
          <ativador-tooltip
            [isBtn]="true"
            label="Resumo da VDP (%)  "
            [tooltipEnabled]="false"
            tooltipText="O formulário ainda não foi enviado"
            (action)="open(content)"
          >
          </ativador-tooltip>
        </div>
      </ng-template>
      <ng-template #needStartEtapaVdp>
        <div class="col-lg-12 button-responsive">
          <button
            [disabled]="loadingButton && isSafraVigenteOuSuperior"
            (click)="openModalIniciarEtapaVdp()"
            class="btn btn-sm btn-primary"
          >
            Iniciar VDP
          </button>
        </div>
      </ng-template>
    </div>
  </div>
  <div class="col-lg-6">
    <app-status-convite
      *ngIf="isStartEtapaVdpVar"
      [loading]="loadingStatus"
      title="Status"
      [status]="status"
    ></app-status-convite>
  </div>
  <div class="col-lg-2 options-content-responsive">
    <dropdown-btn labelAtivadora="Outras opções" *ngIf="isStartEtapaVdpVar">
      <dropdown-btn-item
        *ngIf="safraVigenteAtivaStatusVDPEmAndamentoCompleto"
        (actionPerformed)="reenviarEmail()"
      >
        Reenviar e-mail VDP
      </dropdown-btn-item>
      <dropdown-btn-item
        *ngIf="podePularVdp"
        (actionPerformed)="openModalEtapaVdp('pular-etapa')"
      >
        Pular etapa <strong>VDP e PCNC</strong>
      </dropdown-btn-item>
      <dropdown-btn-item
        (actionPerformed)="open(nota)"
        *ngIf="exibirNotaExplicativa"
      >
        Acessar <strong>Nota Explicativa</strong>
      </dropdown-btn-item>
      <dropdown-btn-item *ngIf="podeSolicitarRetorno">
        <modal-retorno
          [etapa]="'VDP'"
          [etapaAtual]="etapaAtual"
          [unidadeProdutiva]="unidadeProdutiva"
        ></modal-retorno>
      </dropdown-btn-item>
    </dropdown-btn>
  </div>
</div>
<div class="d-flex justify-content-end" *ngIf="validaSeguirParaVcp">
  <div>
    <button
      class="btn btn-sm btn-danger m-1"
      (click)="openModalConcluirPcnc('nao-realizar-processo')"
    >
      A Unidade Produtiva não realizará o processo de Certificação (VCP)</button
    >&nbsp;
    <button
      class="btn btn-sm btn-success m-1"
      (click)="openModalConcluirPcnc('realizar-processo')"
    >
      A Unidade Produtiva realizará o processo de Certificação (VCP)
    </button>
  </div>
</div>
<br />

<basic-modal #modalEtapaFluxoVcp [modalConfig]="modalEtapaFluxoVcpConfig">
  <div>
    <p>{{ textBodyModalEtapaVcp }}</p>
  </div>
</basic-modal>

<ng-template #content let-modal>
  <modal-etapa-vdp-nota
    [containerNota]="containerNota"
    [unidadeProdutiva]="unidadeProdutiva"
    [modal]="modal"
  ></modal-etapa-vdp-nota>
</ng-template>

<ng-template #nota let-modal>
  <app-modal-vdp-nota-explicativa
    (notaEnviada)="loading()"
    [modal]="modal"
    *ngIf="!notaExplicativa"
    [unidadeProdutiva]="unidadeProdutiva"
  >
  </app-modal-vdp-nota-explicativa>
  <app-modal-vdp-nota-explicativa-preenchida
    [modal]="modal"
    *ngIf="notaExplicativa"
    [unidadeProdutiva]="unidadeProdutiva"
  >
  </app-modal-vdp-nota-explicativa-preenchida>
</ng-template>

<basic-modal #modalEtapaVdp [modalConfig]="modalEtapaVdpConfig">
  <div>
    <p>{{ textBodyModal }}</p>
  </div>
</basic-modal>

<basic-modal
  #modalIniciarPreenchimentoVdp
  [modalConfig]="modalIniciarPreenchimentoVdpConfig"
>
  <div>
    <p>
      Ao iniciar a etapa VDP, o formulário será liberado para preenchimento.
      Você confirma que deseja iniciar esta etapa?
    </p>
  </div>
</basic-modal>
